module.exports = __webpack_public_path__ + "media/create_client.c0270aa8.mp4";